enum TicketingSource {
    NGAGE = 'ngage',
    DIGITICKETS = 'digitickets',
}

export default TicketingSource;